export default "__VITE_ASSET__bMQ5X9i$__"